// ریز اقلام حواله پرداخت تملک دارایی‌های سرمایه‌ای
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa   = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng  = s => String(s ?? '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const fmtNum = n => n ? Number(n).toLocaleString('fa-IR') : '•';
const num    = v => { const n = Number(toEng(String(v)).replace(/,/g, '')); return isNaN(n) ? 0 : n; };

const EMPTY = {
  amount: '', fund_pay: '', prepayment: '', on_account: '', remark: '',
  credit_id: 0, credit: '', program_id: 0, program: '', project_id: 0, project: '',
  hazineh_id: 0, hazineh: '', cost_center_id: 0, cost_center: '',
};

const API = (path, opts = {}) => fetch(`/api/budget${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

const Field = ({ label, value, onChange, type = 'text', flex = 1, disabled }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex }}>
    <label style={ui.mlabel}>{label}</label>
    <input type={type} value={value} onChange={onChange} disabled={disabled}
      style={{ ...ui.input, background: disabled ? '#f2f2f2' : '#fff' }} />
  </div>
);

function Lookup({ label, value, endpoint, extra = '', onPick, flex = 1, renderRow, disabled }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => {
    setQ(text);
    const j = await API(`${endpoint}?q=${encodeURIComponent(text)}${extra}`);
    if (j.ok) { setRows(j.rows); setOpen(true); }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => !disabled && search(q)} onChange={e => !disabled && search(e.target.value)}
        placeholder="جستجو..." disabled={disabled}
        style={{ ...ui.input, background: disabled ? '#f2f2f2' : '#fff' }} />
      {value && !disabled && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 700, maxHeight: '260px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
              {renderRow ? renderRow(r) : r.display}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function BudgetTamalokHavalehDetail({ user, onBack, havaleh, programType = 1, tab = 'budget' }) {
  // دکمه‌های فرم FRMBUDGETHAVALEHDETAIL — دیدن = دسترسی
  const vbf0 = useFormButtons('FRMBUDGETHAVALEHDETAIL', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK","BTNCREDITPLACE"]);
  // از تب اعتبارات اقلام فقط دیده می‌شوند (ثبت، ویرایش و حذف ندارد)
  const [mode, setMode] = useState(tab);
  const vbf = { ...vbf0, can: b => mode !== 'credit' && vbf0.can(b) };
  // «تامین اعتبار» فقط از تب اعتبارات (یا حالت هر دو)
  const canCreditPlace = mode !== 'budget' && vbf0.can('BTNCREDITPLACE');
  const [cp, setCp] = useState(null);   // {paid, scope}
  const pk = programType === 0 ? 0 : 1;   // نوع برنامه برای جستجوی محل اعتبار
  const HID = havaleh?.id;
  const kind = havaleh?.kind ?? 0;
  const payAllowed = kind > 1;

  const [head,   setHead]   = useState(havaleh || null);
  const [data,     setData]     = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading,  setLoading]  = useState(false);
  const [modal,    setModal]    = useState(null);
  const [form,     setForm]     = useState(EMPTY);
  const [saving,   setSaving]   = useState(false);
  const [error,    setError]    = useState('');
  const [toast,    setToast]    = useState('');

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 3000); };

  const cols = ['محل تأمین اعتبار', 'کد هزینه', 'مرکز هزینه', 'مبلغ حواله', 'تنخواه', 'پیش‌پرداخت', 'علی‌الحساب', 'جمع هزینه', 'شرح', 'تامین اعتبار'];
  const initW = [300, 160, 130, 120, 110, 110, 110, 120, 150, 80];

  // تامین اعتبار: وضعیت پیشنهادی بعد از وضعیت فعلی (بدون ← موقت ← قطعی ← بدون)
  const openCreditPlace = () => {
    if (!canCreditPlace || !selected) return;
    setCp({ paid: [1, 2, 0][selected.paid_allowed || 0], scope: 0 });
  };
  const applyCreditPlace = async (send) => {
    const body = { paid_allowed: cp.paid, scope: cp.scope, tab };
    if (send !== undefined) body.send_to_accounting = send;
    const j = await API(`/budget-havaleh/detail/${selected.id}/paid-allowed/?tab=${tab}`, { method: 'POST', body: JSON.stringify(body) });
    if (j.needs_confirm) { return applyCreditPlace(window.confirm(j.msg)); }
    if (!j.ok) { setError(j.msg); return; }
    setCp(null); showToast([j.msg, ...(j.notes || [])].join(' — ')); load();
  };
  const [colW, setColW] = useState(initW);
  const colWRef = useRef(initW);
  useEffect(() => { colWRef.current = colW; }, [colW]);
  const startResize = useCallback((idx, e) => {
    e.preventDefault(); e.stopPropagation();
    const sx = e.clientX, sw = colWRef.current[idx];
    const onMove = ev => setColW(w => { const n = [...w]; n[idx] = Math.max(40, sw + (sx - ev.clientX)); return n; });
    const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
    document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
  }, []);

  const load = useCallback(async () => {
    if (!HID) return;
    setLoading(true); setError(''); setSelected(null);
    const j = await API(`/budget-havaleh/${HID}/detail/?tab=${tab}`);
    setLoading(false);
    if (j.ok) { setData(j.data); if (j.head) { setHead(h => ({ ...h, ...j.head })); if (j.head.mode) setMode(j.head.mode); } }
    else setError(j.msg);
  }, [HID]);

  useEffect(() => { load(); }, [load]);

  const sumHavaleh = data.reduce((a, r) => a + (r.amount || 0), 0);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew  = () => { if (!vbf.can('BTNNEW')) return; setForm(EMPTY); setModal('new'); };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    setForm({
      amount: selected.amount || '', fund_pay: selected.fund_pay || '', prepayment: selected.prepayment || '',
      on_account: selected.on_account || '', remark: selected.remark || '',
      credit_id: selected.credit_id || 0, credit: selected.credit || '',
      program_id: selected.program_id || 0, program: selected.program || '',
      project_id: selected.project_id || 0, project: selected.project || '',
      hazineh_id: selected.hazineh_id || 0, hazineh: selected.hazineh || '',
      cost_center_id: selected.cost_center_id || 0, cost_center: selected.cost_center || '',
    });
    setModal('edit');
  };
  const openDel = () => { if (!vbf.can('BTNDELETE')) return; if (selected) setModal('delete'); };

  const detailNet = num(form.amount) - num(form.fund_pay) - num(form.prepayment) - num(form.on_account);

  const save = async () => {
    if (detailNet < 0) { setError('جمع حواله منفی است'); return; }
    setSaving(true); setError('');
    const body = JSON.stringify({
      amount: form.amount, fund_pay: payAllowed ? form.fund_pay : 0,
      prepayment: payAllowed ? form.prepayment : 0, on_account: payAllowed ? form.on_account : 0,
      credit_id: form.credit_id, program_id: form.program_id, project_id: form.project_id,
      hazineh_id: form.hazineh_id, cost_center_id: form.cost_center_id, remark: form.remark,
    });
    const j = modal === 'new'
      ? await API(`/budget-havaleh/${HID}/detail/create/?tab=${tab}`, { method: 'POST', body })
      : await API(`/budget-havaleh/detail/${selected.id}/update/?tab=${tab}`, { method: 'PUT', body });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(); }
    else setError(j.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/budget-havaleh/detail/${selected.id}/delete/?tab=${tab}`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('حذف شد'); load(); }
    else { setError(j.msg); setModal(j.used ? 'delete_blocked' : null); }
  };

  const toolbar = (
    <>
      <div style={ui.toolBtns}>
        {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش</button>}
        {vbf.can('BTNDELETE') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
        {canCreditPlace && data.length > 0 && <button onClick={openCreditPlace} disabled={!selected}
          style={{ ...ui.btnItems, background: 'linear-gradient(135deg,#1b5e20,#2e7d32)', opacity: selected ? 1 : 0.4 }}>✔ تامین اعتبار</button>}
        {cp && (
          <span style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 12, background: '#e8f5e9', padding: '4px 8px', borderRadius: 7 }}>
            <select value={cp.paid} onChange={e => setCp(c => ({ ...c, paid: Number(e.target.value) }))} style={ui.input}>
              <option value={0}>---</option><option value={1}>موقت</option><option value={2}>قطعی</option>
            </select>
            <select value={cp.scope} onChange={e => setCp(c => ({ ...c, scope: Number(e.target.value) }))} style={ui.input}>
              <option value={0}>همین قلم</option><option value={1}>همهٔ اقلام حواله</option>
            </select>
            <button onClick={() => applyCreditPlace()} style={ui.btnSave}>ثبت</button>
            <button onClick={() => setCp(null)} style={ui.btnCancel}>انصراف</button>
          </span>
        )}
      </div>
      <div style={{ padding: '6px 14px', background: '#1b5e20', color: '#fff', borderRadius: '20px', fontSize: '12px', fontWeight: '700', marginRight: 'auto', alignSelf: 'flex-end' }}>
        جمع کل حواله: {fmtNum(sumHavaleh)} ریال
      </div>
      {loading && <span>⏳</span>}
    </>
  );

  return (
    <>
      <ListPage user={user} onBack={onBack}
        title={`اقلام حواله شماره ${toFa(head?.request_no || head?.havaleh_no)}`}
        subtitle={`${head?.kind_name || ''} — تاریخ ${head?.havaleh_date || '—'}`}
        toolbar={toolbar} error={!modal ? error : ''}>
        <table style={{ ...ui.table, tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
            <tr>
              {cols.map((h, i) => (
                <th key={i} style={{ ...ui.th, width: colW[i], minWidth: 40, position: 'relative', userSelect: 'none' }}>
                  {h}<span onMouseDown={e => startResize(i, e)} style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', cursor: 'col-resize' }} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => {
              const sel = selected?.id === r.id;
              const bg  = sel ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf6e3';
              const tc  = sel ? '#fff' : '#111';
              const n = (v, color) => <td style={{ ...ui.tdNum, color: sel ? '#fff' : v ? color : '#ccc' }}>{fmtNum(v)}</td>;
              return (
                <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                  onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                  <td style={{ ...ui.td, textAlign: 'right', fontSize: '10px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.credit_place}>{r.credit_place || '•'}</td>
                  <td style={{ ...ui.td, textAlign: 'right', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.hazineh}>{r.hazineh || '•'}</td>
                  <td style={{ ...ui.td, textAlign: 'right', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.cost_center}>{r.cost_center || '•'}</td>
                  {n(r.amount, '#1b5e20')}
                  {n(r.fund_pay, '#e65100')}
                  {n(r.prepayment, '#6a1b9a')}
                  {n(r.on_account, '#6a1b9a')}
                  {n(r.net, '#1a237e')}
                  <td style={{ ...ui.td, textAlign: 'right', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.remark}>{r.remark || '•'}</td>
                  <td style={{ ...ui.td, fontSize: '11px', fontWeight: 700, color: sel ? '#fff' : r.paid_allowed === 2 ? '#1b5e20' : r.paid_allowed === 1 ? '#e65100' : '#aaa' }}>{r.paid_allowed_name || '---'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!loading && data.length === 0 && <div style={ui.empty}>📭 قلمی ثبت نشده است</div>}
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '780px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ قلم جدید حواله' : '✎ ویرایش قلم حواله'}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}

              <div style={{ fontSize: '12px', fontWeight: '700', color: '#1a2f50', marginBottom: '8px' }}>محل تأمین اعتبار</div>
              <div style={ui.row}>
                <Lookup label="منبع اعتبار" value={form.credit} endpoint="/transactions/lookup/credit/" extra={`&kind=${pk}`}
                  onPick={r => setForm(f => ({ ...f, credit_id: r.id, credit: r.display }))} flex={2} />
              </div>
              <div style={ui.row}>
                <Lookup label={pk === 1 ? 'طرح' : 'برنامه'} value={form.program} endpoint="/transactions/lookup/program/" extra={`&kind=${pk}`}
                  onPick={r => setForm(f => ({ ...f, program_id: r.id, program: r.display }))} />
                <Lookup label={pk === 1 ? 'پروژه' : 'فعالیت'} value={form.project} endpoint="/transactions/lookup/project/" extra={`&kind=${pk}`}
                  onPick={r => setForm(f => ({ ...f, project_id: r.id, project: r.display }))} />
              </div>
              <div style={ui.row}>
                <Lookup label="کد هزینه" value={form.hazineh} endpoint="/transactions/lookup/hazineh/" extra={`&kind=${pk}`}
                  onPick={r => setForm(f => ({ ...f, hazineh_id: r.id, hazineh: r.display }))} />
                <Lookup label="مرکز هزینه" value={form.cost_center} endpoint="/hazineh-havaleh/lookup/cost-center/"
                  onPick={r => setForm(f => ({ ...f, cost_center_id: r.id, cost_center: r.display }))} />
              </div>

              <div style={ui.divider} />
              <div style={ui.row}>
                <Field label="مبلغ حواله" value={form.amount} onChange={e => F('amount', e.target.value)} type="number" />
                <Field label="تنخواه" value={form.fund_pay} onChange={e => F('fund_pay', e.target.value)} type="number" disabled={!payAllowed} />
              </div>
              <div style={ui.row}>
                <Field label="پیش‌پرداخت" value={form.prepayment} onChange={e => F('prepayment', e.target.value)} type="number" disabled={!payAllowed} />
                <Field label="علی‌الحساب" value={form.on_account} onChange={e => F('on_account', e.target.value)} type="number" disabled={!payAllowed} />
              </div>
              {!payAllowed && <div style={{ fontSize: '11px', color: '#888', marginTop: '-4px', marginBottom: '8px' }}>در نوع «{head?.kind_name}» تنخواه/پیش‌پرداخت/علی‌الحساب کاربرد ندارد</div>}
              <div style={{ background: '#f0f4ff', borderRadius: '8px', padding: '8px 12px', fontSize: '13px', fontWeight: '700', color: detailNet < 0 ? '#b71c1c' : '#1a237e', marginBottom: '12px' }}>
                جمع هزینه سطر: {fmtNum(detailNet)} ریال
              </div>
              <div style={ui.row}>
                <Field label="شرح" value={form.remark} onChange={e => F('remark', e.target.value)} />
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '420px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف قلم</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '26px' }}>
              <div style={{ fontSize: '34px', marginBottom: '10px' }}>🗑️</div>
              مبلغ {fmtNum(selected?.amount)} ریال — {selected?.hazineh || selected?.credit_place}
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete_blocked' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '440px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#e65100,#f57c00)' }}>
              <div style={ui.mTitle}>🚫 عدم امکان حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '26px', fontWeight: '700', color: '#1a2f50', lineHeight: '1.8' }}>{error}</div>
            <div style={ui.mFooter}><button onClick={() => { setModal(null); setError(''); }} style={ui.btnSave}>باشه</button></div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}
